import React, { useEffect, useState } from "react";
import { ArrowRightIcon, PlayIcon } from "@heroicons/react/24/solid";
import Login from "views/Login";
import { Link } from "react-router-dom";

const WaveBackground = ({ children }) => (
  <section className="relative min-h-[600px] overflow-hidden bg-[#0b5c2a]">
    <div className="absolute inset-0 bg-gradient-to-br from-[#1c9b4a] via-[#087236] to-[#063717]" />
    <div className="absolute inset-0 bg-[radial-gradient(circle_at_45%_35%,rgba(44,185,92,0.35),transparent_42%)]" />

    {children}

    <svg
      className="absolute bottom-0 left-0 h-[300px] w-full md:h-[300px]"
      viewBox="0 0 1440 220"
      preserveAspectRatio="none"
      aria-hidden="true"
    >
      <path
        fill="#fff"
        d="M0,176 C210,204 415,168 636,140 C870,110 1025,112 1212,140 C1305,154 1375,164 1440,162 L1440,220 L0,220 Z"
      />
    </svg>
  </section>
);

export default function Hero() {
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem("token"));

  const toggleLoginPopup = () => setIsLoginOpen(!isLoginOpen);
  const closeLoginPopup = () => setIsLoginOpen(false);
  const handleLoginSuccess = () => {
    setIsLoggedIn(true);
    closeLoginPopup();
  };

  useEffect(() => {
    // Keep login state in sync
    const checkLogin = () => setIsLoggedIn(!!localStorage.getItem("token"));
    window.addEventListener("storage", checkLogin);
    return () => window.removeEventListener("storage", checkLogin);
  }, []);

  return (
    <WaveBackground>
      <div className="relative z-10 mx-auto flex min-h-[1050px] w-full max-w-7xl flex-col items-center justify-center px-5 pb-24 pt-28 text-center text-white md:pb-32 md:pt-24">
        <h1 className="max-w-8xl text-5xl font-bold leading-tight tracking-normal sm:text-5xl md:text-8xl">
          DIAJENG LEARNING
        </h1>

        <p className="mt-3 text-base font-normal text-white/90 md:text-4xl">
          Digitalisasi Madrasah Jawa Tengah
        </p>

        <div className="mt-12 flex flex-wrap items-center justify-center gap-3">
          <button
            onClick={toggleLoginPopup}
            type="button"
            className="hover:bg-slate-100 inline-flex h-11 items-center gap-2 rounded-md bg-white px-8 text-lg font-semibold text-[#0b6b2c] shadow-sm transition"
          >
            Login
            <ArrowRightIcon className="h-4 w-4" />
          </button>

          <Link
            to="https://www.youtube.com/@GeschoolTutorial/videos"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex h-11 items-center gap-2 rounded-md border border-white/35 bg-white/10 px-5 text-lg font-semibold text-white backdrop-blur transition hover:bg-white/20"
          >
            <span className="inline-flex h-6 w-6 items-center justify-center rounded-full bg-white/25">
              <PlayIcon className="h-3.5 w-3.5" />
            </span>
            Lihat Tutorial
          </Link>
        </div>
        {isLoginOpen && (
          <Login
            closePopup={closeLoginPopup}
            onLoginSuccess={handleLoginSuccess}
          />
        )}
      </div>
    </WaveBackground>
  );
}
